// Core Web Vitals — sent to GA4 as `web_vital` events (only after consent),
// and logged to the console in dev mode for local debugging.
//
// In production : silently forwarded to GA4 once analytics consent fires.
// In dev        : console.log with a colour-coded rating so we can see the
//                 metric in DevTools without flipping to the Network tab.

import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';
import { trackEvent } from './analytics';

// CLS is a unitless ratio; the others are milliseconds. GA expects integers
// in event params, so we scale CLS by 1000 to preserve precision.
function send(metric) {
  const { name, value, delta, id, rating, navigationType } = metric;
  const scale = name === 'CLS' ? 1000 : 1;
  const scaledValue = Math.round(value * scale);

  // GA4 forwarding — fires only after analytics consent has been granted.
  trackEvent('web_vital', {
    metric_name: name,
    metric_value: scaledValue,
    metric_delta: Math.round(delta * scale),
    metric_id: id,
    metric_rating: rating,
    navigation_type: navigationType,
  });

  // Dev-mode logging — colour-coded by rating so Jade can spot regressions
  // in DevTools at a glance. No-op in production (Vite strips this entire
  // block via `import.meta.env.DEV` constant folding).
  if (import.meta.env.DEV) {
    const color =
      rating === 'good'              ? 'color:#0F6E56;font-weight:bold'
      : rating === 'needs-improvement' ? 'color:#C7A65A;font-weight:bold'
      : rating === 'poor'              ? 'color:#7E2723;font-weight:bold'
      : 'color:#666';
    const unit = name === 'CLS' ? '' : 'ms';
    // eslint-disable-next-line no-console
    console.log(
      `%c[Web Vital] ${name}: ${name === 'CLS' ? value.toFixed(3) : Math.round(value)}${unit} (%s)`,
      color,
      rating,
    );
  }
}

export function reportWebVitals() {
  if (typeof window === 'undefined') return;
  onCLS(send);
  onINP(send);
  onLCP(send);
  onFCP(send);
  onTTFB(send);
}
